module.exports = __webpack_public_path__ + "static/media/slideshow-foto-04.170a1ffa.png";